import { useEffect } from 'react';
import { getSocket } from './socketClient';

// eventMap: { 'task_updated': handler, 'task_created': handler, ... }
// El caller debe memoizar eventMap (useMemo/useCallback) para no re-suscribir en cada render.
export function useSocket(eventMap) {
    useEffect(() => {
        const socket = getSocket();
        const entries = Object.entries(eventMap);
        entries.forEach(([event, handler]) => socket.on(event, handler));
        return () => {
            entries.forEach(([event, handler]) => socket.off(event, handler));
        };
    }, [eventMap]);
}
